var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[(!_vm.isMobile)?_c('v-col',{staticClass:"img-col",attrs:{"cols":"12","md":"7","lg":"8"}}):_vm._e(),_c('v-col',{attrs:{"cols":"12","md":"5","lg":"4"}},[_c('confirm-mail',{staticClass:"mt-7"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }